import { CHICLET_LIST } from 'crm-cards-sdk/constants/LoadingComponentProps';
import ChicletListSkeleton from 'crm-cards-sdk/components/skeletons/ChicletListSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
function ChickletCardContentSkeleton({
  cardId,
  numberOfSkeletons,
  numberOfProperties
}) {
  return /*#__PURE__*/_jsx(ChicletListSkeleton, {
    cardId: cardId,
    type: CHICLET_LIST,
    numberOfSkeletons: numberOfSkeletons || 1,
    numberOfProperties: numberOfProperties
  });
}
export default ChickletCardContentSkeleton;